// extracted by mini-css-extract-plugin
export default {"seperator":"style_seperator__IGglw"};